import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#004C68',
      light: '#005E80',
      dark: '#003A50',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#3B7D9C',
      light: '#5B9DBD',
      dark: '#1B5D7C',
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#E56464',
      light: '#FDEBEB',
      dark: '#B91C1C',
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#F0B056',
      light: '#FEF7E6',
      dark: '#92400E',
      contrastText: '#1D2939',
    },
    info: {
      main: '#3B7D9C',
      light: '#E0F2FE',
      dark: '#004C68',
      contrastText: '#FFFFFF',
    },
    success: {
      main: '#5BB98C',
      light: '#E6F4EA',
      dark: '#276749',
      contrastText: '#FFFFFF',
    },
    text: {
      primary: '#1D2939',
      secondary: '#475467',
      disabled: '#667085',
    },
    background: {
      default: '#F5F7F9',
      paper: '#FFFFFF',
    },
    divider: '#D0D5DD',
    action: {
      active: '#003A50',
      hover: '#005E80',
      selected: '#D8E5EC',
      disabled: '#667085',
      disabledBackground: '#E1E6EB',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 500,
      color: '#1D2939',
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 500,
      color: '#1D2939',
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 500,
      color: '#1D2939',
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 500,
      color: '#1D2939',
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 500,
      color: '#1D2939',
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 500,
      color: '#1D2939',
    },
    body1: {
      color: '#1D2939',
    },
    body2: {
      color: '#475467',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          '&:hover': {
            backgroundColor: '#005E80',
          },
          '&:active': {
            backgroundColor: '#003A50',
          },
          '&:focus': {
            boxShadow: '0 0 0 2px #CCE2EB',
          },
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
          backgroundColor: '#FFFFFF',
          '&:hover': {
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#004C68',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#F5F7F9',
          color: '#1D2939',
          borderRadius: 0,
          borderRight: '1px solid #D0D5DD',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: '#D8E5EC',
            color: '#1D2939',
            '&:hover': {
              backgroundColor: '#D8E5EC',
            },
          },
          '&:hover': {
            backgroundColor: 'rgba(0, 76, 104, 0.08)',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: '#E1E6EB',
          color: '#1D2939',
          fontWeight: 600,
        },
        root: {
          borderBottom: '1px solid #D0D5DD',
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          transition: 'none',
          '&:hover': {
            boxShadow: 'none',
            transform: 'none',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 6,
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
        standardSuccess: {
          backgroundColor: '#E6F4EA',
          color: '#276749',
          '& .MuiAlert-icon': {
            color: '#5BB98C',
          },
        },
        standardWarning: {
          backgroundColor: '#FEF7E6',
          color: '#92400E',
          '& .MuiAlert-icon': {
            color: '#F0B056',
          },
        },
        standardError: {
          backgroundColor: '#FDEBEB',
          color: '#B91C1C',
          '& .MuiAlert-icon': {
            color: '#E56464',
          },
        },
        standardInfo: {
          backgroundColor: '#E0F2FE',
          color: '#004C68',
          '& .MuiAlert-icon': {
            color: '#3B7D9C',
          },
        },
      },
    },
  },
});

export default theme;